import "./modals.js";

(function () {
  document.addEventListener("DOMContentLoaded", () => {
    const header = document.querySelector("[data-header]");
    const toggle = document.querySelector("[data-mobile-menu-toggle]");
    const panel = document.querySelector("[data-mobile-menu]");

    if (header) {
      const scrollThreshold = 12;
      const syncScrolledState = () => {
        header.classList.toggle("is-scrolled", window.scrollY > scrollThreshold);
      };

      syncScrolledState();
      window.addEventListener("scroll", syncScrolledState, { passive: true });
    }

    if (!header || !toggle || !panel) {
      return;
    }

    const mobileQuery = window.matchMedia("(max-width: 1023px)");
    const isOpen = () => panel.classList.contains("is-open");
    let lockedScrollY = 0;

    const lockBodyScroll = () => {
      lockedScrollY = window.scrollY || window.pageYOffset || 0;
      document.documentElement.classList.add("mobile-menu-open");
      document.body.classList.add("mobile-menu-open");
      document.body.style.top = `-${lockedScrollY}px`;
    };

    const unlockBodyScroll = () => {
      document.documentElement.classList.remove("mobile-menu-open");
      document.body.classList.remove("mobile-menu-open");
      document.body.style.top = "";
      window.scrollTo(0, lockedScrollY);
    };

    const openMenu = () => {
      panel.removeAttribute("hidden");
      panel.setAttribute("aria-hidden", "false");
      panel.classList.add("is-open");
      toggle.classList.add("is-active");
      header.classList.add("is-menu-open");
      toggle.setAttribute("aria-expanded", "true");
      lockBodyScroll();
    };

    const closeMenu = () => {
      panel.classList.remove("is-open");
      panel.setAttribute("hidden", "");
      panel.setAttribute("aria-hidden", "true");
      toggle.classList.remove("is-active");
      header.classList.remove("is-menu-open");
      toggle.setAttribute("aria-expanded", "false");
      unlockBodyScroll();
    };

    toggle.addEventListener("click", () => {
      if (isOpen()) {
        closeMenu();
        return;
      }

      openMenu();
    });

    panel.querySelectorAll("a").forEach((link) => {
      link.addEventListener("click", closeMenu);
    });

    document.addEventListener("keydown", (event) => {
      if (event.key === "Escape" && isOpen()) {
        closeMenu();
        toggle.focus();
      }
    });

    mobileQuery.addEventListener("change", (event) => {
      if (!event.matches && isOpen()) {
        closeMenu();
      }
    });
  });
})();
